<template>
  <section
    class="lg:container py-[60px] md:py-[100px] calculate-bike-size overflow-x-hidden"
  >
    <h1
      class="px-4 lg:px-0 mb-4 md:mb-[32.25px] mt-0 text-[24px] font-ff-good-pro-cond uppercase font-bold !leading-[32px] md:text-[32px] md:!leading-[40px] text-center text-secondary"
    >
      {{ $t("common.calculate_your_size") }}
    </h1>

    <!-- filters -->
    <div class="flex flex-row items-start justify-between gap-3 px-4 lg:px-0">
      <div
        class="flex flex-row items-center justify-between w-full md:w-auto md:justify-start md:items-start md:flex-col"
      >
        <a
          href="#"
          @click.stop="goBack"
          class="flex items-center gap-1 text-sm font-bold md:text-base text-secondary font-ff-good-pro-cond"
        >
          <ArrowLeft class="w-[18px] h-[18px] text-secondary" />
          {{ $t("common.go_back_to_calculator") }}
        </a>
      </div>
      <div
        class="flex flex-row items-center justify-end w-full gap-2.5 md:w-auto"
      >
        <!-- <span
          v-if="productsCount"
          class="font-medium text-base leading-[30px] font-ff-good-pro-cond text-black"
        >
          {{ productsCount }} {{ $t("common.results") }}
        </span>
        <span
          v-if="productsCount"
          class="w-1 h-1 rounded-full bg-[#C5C6C7]"
        ></span> -->
        <span
          class="flex sm:flex-row flex-col justify-start gap-1.5 font-ff-good-pro-cond"
        >
          <span class="text-sm font-bold uppercase text-dark-gray-600">
            {{ $t("common.height") }}:
          </span>
          <span class="text-sm font-medium text-black whitespace-nowrap">
            <strong class="font-medium">
              {{ calculateBikeSizeStore.form.height }}
            </strong>
            {{ calculateBikeSizeStore.form.unit }}
          </span>
        </span>
        <span
          class="hidden md:inline-block w-1 h-1 rounded-full bg-[#C5C6C7]"
        ></span>
        <span
          class="flex sm:flex-row flex-col justify-start gap-1.5 font-ff-good-pro-cond"
        >
          <span class="text-sm font-bold uppercase text-dark-gray-600">
            {{ $t("common.inner_leg_length") }}:
          </span>
          <span class="text-sm font-medium text-black whitespace-nowrap">
            <strong class="font-medium">
              {{ calculateBikeSizeStore.form.inner_leg_length }}
            </strong>
            {{ calculateBikeSizeStore.form.unit }}
          </span>
        </span>
      </div>
    </div>

    <!-- product list -->
    <CcbsBikeModel
      v-if="
        calculateBikeSizeStore.bikeModel &&
        !Array.isArray(calculateBikeSizeStore.bikeModel)
      "
    />
    <div
      v-else
      class="flex items-center flex-col justify-center w-full pt-5 md:pt-[70px]"
    >
      <EmptyCCBS class="max-w-[330px] md:max-w-[400px]" />
      <h2
        class="mb-0 mt-0 md:mt-[30px] font-ff-good-pro-cond font-bold text-[26px] leading-[34px] text-center text-secondary"
      >
        {{ $t("common.no_match_found") }}
      </h2>
      <p class="text-base text-[#373737] font-ff-good-pro-cond">
        {{ $t("common.bike_size_not_found") }}
      </p>
    </div>
  </section>
</template>
<script setup>
import ArrowLeft from "~/assets/svg/heroicons/arrow-left.svg?component";
import EmptyCCBS from "~/assets/svg/bike-modal-not-found.svg?component";
import { useCalculateBikeSizeStore } from "~/store/calculatebikesize";

const calculateBikeSizeStore = useCalculateBikeSizeStore();
const emit = defineEmits();

const productsCount = ref(0);
const height = ref(calculateBikeSizeStore.form.height);
const innerLegLength = ref(calculateBikeSizeStore.form.inner_leg_length);

function updateHeight(value) {
  calculateBikeSizeStore.updateForm("height", value);
}

function updateInnerLength(value) {
  calculateBikeSizeStore.updateForm("inner_leg_length", value);
}

function goBack() {
  calculateBikeSizeStore.hasCompleted(false);
  const timeout = setTimeout(() => {
    const containerEl = document.getElementById("calculate");
    if (containerEl) {
      containerEl.scrollIntoView({
        behavior: "smooth",
      });
    }
    clearTimeout(timeout);
  }, 5);
}
</script>
<style scoped>
.calculate-bike-size [type="radio"]:checked {
  background-image: url("data:image/svg+xml;charset=utf-8,<svg xmlns='http://www.w3.org/2000/svg' fill='#000' viewBox='0 0 16 16'><circle cx='8' cy='8' r='3'/></svg>") !important;
}
</style>